import { DetailedHTMLProps, ImgHTMLAttributes, useState } from 'react';
import classNames from 'classnames';
import { CgSpinner } from '@react-icons/all-files/cg/CgSpinner';

const loaderSizes = {
  normal: 'text-4xl',
  small: 'text-2xl',
};

interface LoaderProps {
  isLoading: boolean;
  size?: keyof typeof loaderSizes;
  className?: string;
  src?: string;
}

export function Loader({
  isLoading,
  size = 'normal',
  className,
  src,
}: LoaderProps) {
  return (
    <div
      className={classNames(
        'absolute flex inset-0 bg-gray-300 items-center justify-center transition-all',
        isLoading ? 'opacity-100' : 'hidden',
        className,
      )}
    >
      {isLoading && (
        <div className="p-10">
          <CgSpinner
            className={classNames(
              'animate-spin text-gray-500',
              loaderSizes[size],
              src === null && 'opacity-0',
            )}
          />
        </div>
      )}
    </div>
  );
}

export function ImageWithLoader(
  props: DetailedHTMLProps<
    ImgHTMLAttributes<HTMLImageElement>,
    HTMLImageElement
  >,
) {
  const [isLoading, setIsLoading] = useState(true);
  return (
    <div className="relative">
      <img
        {...props}
        alt="image"
        className={classNames(
          props.className,
          'transition-all',
          isLoading ? 'opacity-0 p-5' : 'opacity-100',
        )}
        onLoad={() => setIsLoading(false)}
      />
      <Loader isLoading={isLoading} src={props.src} />
    </div>
  );
}
